import React from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminLogin, userLogin } from "../Redux/AuthReducer/action";
import {
  ADMIN_LOGIN_SUCCESS,
  USER_LOGIN_SUCCESS,
} from "../Redux/AuthReducer/actionTypes";

export const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const token = useSelector((state) => state.AuthReducer.token);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const comingFrom = location.state?.from?.pathname || "/dashboard";
  console.log("coming from",comingFrom)
  
  const handleLogin = (e) => {
    e.preventDefault();
    
    if(email && password){
      const userData ={
        username:email,
        password:password
      }
     try{
      dispatch(userLogin(userData)).then((r) => {
        if (r === USER_LOGIN_SUCCESS) {
          alert("you are welcome ! Login Successfully")
          navigate(comingFrom, { replace: true });
        } else {
          alert("The Email ID or the Password entered is incorrect.");
        }
      });
     }
     catch(err){
          console.log(err)
     }
    }  
  };
  return (
    <>
      <div className="font-sans text-gray-900 antialiased">
        <div className="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
          <div>
            <img
              className="h-16"
              src="https://masaischool.com/img/navbar/logo.svg"
              alt="MasaiLogo"
            />
          </div>

          <div className="text-left flex flex-col gap-y-[10px] w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
            <div>
              <label className="block font-medium text-sm text-gray-700">
                Email
              </label>
              <input
                onChange={(e) => setEmail(e.target.value)}
                className="p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full"
                type="email"
              />
            </div>
            <div>
              <label className="block font-medium text-sm text-gray-700">
                Password
              </label>
              <input
                onChange={(e) => setPassword(e.target.value)}
                className="p-2 outline-none border size-md border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block mt-1 w-full"
                type="password"
              />
            </div>
            <div className="flex text-top">
              <input
                className="border border-gray-300 rounded"
                type="checkbox"
              />
              <label className="mx-3 mb-1 font-medium text-sm text-gray-700 flex items-center">
                Remember Me
              </label>
            </div>
            <div className="flex flex-row justify-between font-sans text-gray-900 mt-4">
              <div>
                <Link to="/student-signup">
                  {" "}
                  <button className="border rounded-md border-trensparent py-2 px-4 bg-gray-800 hover:bg-gray-700 focus:bg-gray-900 focus:outline-none text-white text-xs font-semibold uppercase cursor-pointer">
                    Signup
                  </button>
                </Link>
              </div>
              <div>
                <Link
                  to={"/send-otp"}
                  className="underline text-sm text-gray-600 hover:text-gray-900 pt-[3px] pb-[3px]"
                >
                  Forgot your password?
                </Link>
              </div>
              <div>
                <button
                  onClick={handleLogin}
                  className="border rounded-md border-trensparent py-2 px-4 bg-gray-800 hover:bg-gray-700 focus:bg-gray-900 focus:outline-none text-white text-xs font-semibold uppercase cursor-pointer"
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
